import React from "react";
import { Box, Grid, Typography, Divider, List, ListItem, ListItemText, LinearProgress } from "@mui/material";

const Resume31 = ({
  color = "#2c3e50", // Midnight Blue theme
  font = "Inter, Roboto, sans-serif",
  fontSize = "14px",
  headingSize = "22px"
}) => {
  return (
    <Box sx={{ 
      width: "210mm", 
      minHeight: "297mm", 
      mx: "auto", 
      bgcolor: "#fff", 
      fontFamily: font,
      boxShadow: "0 0 20px rgba(0,0,0,0.1)",
      display: "flex"
    }}>
      <Grid container>
        {/* Left Column - Dark Sidebar (35%) */}
        <Grid item xs={4.2} sx={{ bgcolor: color, color: "white", p: 4 }}>
          {/* Header in Sidebar */}
          <Box sx={{ mb: 5, textAlign: "center" }}>
            <Typography variant="h4" sx={{ fontWeight: "900", mb: 1, lineHeight: 1.2 }}>
              RICHARD <br/> SANCHEZ
            </Typography>
            <Typography sx={{ fontSize: "14px", letterSpacing: 2, opacity: 0.8, textTransform: "uppercase" }}>
              Marketing Manager
            </Typography>
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, fontSize: "16px", borderBottom: "1px solid rgba(255,255,255,0.2)", pb: 1 }}>
            CONTACT
          </Typography>
          <Box sx={{ mb: 4, "& p": { fontSize: "13px", mb: 1.5, display: "flex", alignItems: "center" } }}>
            <p>📞 +123-456-7890</p>
            <p>✉️ hello@reallygreatsite.com</p>
            <p>📍 Any City, State</p>
            <p>🌐 linkedin.com/in/richard</p>
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, fontSize: "16px", borderBottom: "1px solid rgba(255,255,255,0.2)", pb: 1 }}>
            EXPERTISE
          </Typography>
          <Box sx={{ mb: 4 }}>
            {[
              { name: "Digital Marketing", val: 90 },
              { name: "Public Relations", val: 80 },
              { name: "Team Leadership", val: 85 },
              { name: "Market Analysis", val: 75 }
            ].map((skill) => (
              <Box key={skill.name} sx={{ mb: 2 }}>
                <Typography sx={{ fontSize: "12px", mb: 0.5 }}>{skill.name}</Typography>
                <LinearProgress 
                  variant="determinate" 
                  value={skill.val} 
                  sx={{ 
                    bgcolor: "rgba(255,255,255,0.1)", 
                    "& .MuiLinearProgress-bar": { bgcolor: "white" },
                    height: 4,
                    borderRadius: 2
                  }} 
                />
              </Box>
            ))}
          </Box>

          <Typography sx={{ fontWeight: "bold", mb: 2, fontSize: "16px", borderBottom: "1px solid rgba(255,255,255,0.2)", pb: 1 }}>
            EDUCATION
          </Typography>
          <Box sx={{ mb: 4 }}>
            <Typography sx={{ fontWeight: "bold", fontSize: "13px" }}>Master of Business</Typography>
            <Typography sx={{ fontSize: "12px", opacity: 0.8 }}>Wardiere University</Typography>
            <Typography sx={{ fontSize: "11px", mb: 2, opacity: 0.6 }}>2029 - 2030</Typography>

            <Typography sx={{ fontWeight: "bold", fontSize: "13px" }}>Bachelor of Commerce</Typography>
            <Typography sx={{ fontSize: "12px", opacity: 0.8 }}>Wardiere University</Typography>
            <Typography sx={{ fontSize: "11px", opacity: 0.6 }}>2025 - 2029</Typography>
          </Box>
        </Grid>

        {/* Right Column - Main Content (65%) */}
        <Grid item xs={7.8} sx={{ p: 5, bgcolor: "white",width:"500px" }}>
          <Box sx={{ mb: 5 }}>
            <Typography variant="h5" sx={{ fontWeight: "bold", color: color, mb: 2 }}>
              PROFESSIONAL PROFILE
            </Typography>
            <Typography sx={{ fontSize: fontSize, lineHeight: 1.7, color: "#555" }}>
              Dynamic and creative Marketing Manager with 8+ years of experience in driving brand growth through 
              innovative digital strategies. Expertise in SEO, content marketing, and leading high-performing teams 
              to achieve significant ROI.
            </Typography>
          </Box>

          <Typography variant="h5" sx={{ fontWeight: "bold", color: color, mb: 3 }}>
            WORK EXPERIENCE
          </Typography>

          {[
            {
              company: "Borcelle Studio",
              role: "Senior Marketing Manager",
              period: "2030 - PRESENT",
              tasks: [
                "Spearheaded a 40% growth in organic social media engagement.",
                "Managed a marketing budget of $500k with 100% efficiency.",
                "Implemented new CRM tools to streamline customer acquisition."
              ]
            },
            {
              company: "Fauget Studio",
              role: "Marketing Specialist",
              period: "2025 - 2029",
              tasks: [
                "Reduced customer churn rate by 15% through retention campaigns.",
                "Analyzed market trends to launch 5 successful product lines.",
                "Coordinated with influencers for brand partnership deals."
              ]
            }
          ].map((job, idx) => (
            <Box key={idx} sx={{ mb: 4 }}>
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <Typography sx={{ fontWeight: "bold", fontSize: "16px" }}>{job.role}</Typography>
                <Typography sx={{ fontSize: "12px", fontWeight: "bold", color: color }}>{job.period}</Typography>
              </Box>
              <Typography sx={{ color: "gray", mb: 1.5, fontSize: "14px" }}>{job.company}</Typography>
              <List sx={{ p: 0 }}>
                {job.tasks.map((task, i) => (
                  <ListItem key={i} sx={{ p: 0, mb: 1, alignItems: "flex-start" }}>
                    <Box component="span" sx={{ color: color, mr: 1, mt: -0.5, fontSize: "18px" }}>•</Box>
                    <ListItemText primary={task} primaryTypographyProps={{ fontSize: "13px", color: "#444" }} />
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}

          <Divider sx={{ my: 4 }} />

          <Typography variant="h5" sx={{ fontWeight: "bold", color: color, mb: 2 }}>
            REFERENCES
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Estelle Darcy</Typography>
              <Typography sx={{ fontSize: "12px", color: "gray" }}>CTO, Wardiere Inc.</Typography>
              <Typography sx={{ fontSize: "12px", mt: 0.5 }}>📞 +123-456-7890</Typography>
            </Grid>
            <Grid item xs={6}>
              <Typography sx={{ fontWeight: "bold", fontSize: "14px" }}>Harper Richard</Typography>
              <Typography sx={{ fontSize: "12px", color: "gray" }}>CEO, Wardiere Inc.</Typography>
              <Typography sx={{ fontSize: "12px", mt: 0.5 }}>📞 +123-456-7890</Typography>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Resume31;
export const resumeMeta = {
  hasPhoto: false,
  columns: 2,
  colorOptions: [
    { value: '#2196f3', label: 'Blue' },
    { value: '#4caf50', label: 'Green' },
    { value: '#ff9800', label: 'Orange' },
    { value: '#9c27b0', label: 'Purple' },
    { value: '#f44336', label: 'Red' }
  ]
};